import { render, staticRenderFns } from "./NoContact.vue?vue&type=template&id=38418448"
import script from "./NoContact.vue?vue&type=script&lang=ts"
export * from "./NoContact.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports